export enum ChannelSettingsChatTypes {
  GET_CHAT_CONFIG = 'channelSettings/GET_CHAT_CONFIG',
  GET_CHAT_CONFIG_LOADING = 'channelSettings/GET_CHAT_CONFIG_LOADING',
  UPDATE_CHAT_CONFIG = 'channelSettings/UPDATE_CHAT_CONFIG',
}

export interface Translations {
  startNewChat?: { [key: string]: string };
  metaMessages?: {
    [key: string]: {
      CUSTOMER?: string;
      AGENT?: string;
      SYSTEM?: string;
      you?: string;
      leftTheChat?: string;
      joinedTheChat?: string;
      chatEnded?: string;
      chatTransferredSuccesfully?: string;
      chatTransferFailed?: string;
    };
  };
  endChatDialogue?: {
    [key: string]: {
      endChatText?: string;
      endChatCancel?: string;
      endChatConfirm?: string;
    };
  };
  sendText?: { [key: string]: string };
}

export interface IChatConfigFields {
  agentDisplayName?: string;
  agentLogoURL?: string;
  allowedAttributes?: string[];
  connectionDetails: Record<string, IConnectionDetails>;
  customerIconURL?: string;
  defaultInputOn?: boolean;
  disableOnCloseConfirmAlert?: boolean;
  endChatButton?: IEndChatButton;
  fileUpload?: IFileUpload;
  fontSources?: IFontSources[];
  globalRestoreSession?: boolean;
  loaderConfig: any;
  logoURL?: string;
  restoreSession?: boolean;
  sendMessagePlaceholder?: string;
  showOnCloseConfirmAlert?: string;
  showStartNewChatButton?: boolean;
  systemDisplayName?: string;
  theme?: Record<string, string>;
  attachmentsConfig?: {
    acceptedFileTypes: string[];
  };
  appTextTranslationOverrides?: Translations;
}

export interface IChatTimes {
  on: string
  off: string
}

export interface IChatServiceFields {
  active: boolean
  weeklyTimes: Record<string, IChatTimes[]>
  overrideDates?: Record<string, IChatTimes[]>
  countryCode?: string


  agentDisplayName: string,
  systemDisplayName: string,
  customerMessagePlaceholder: string;
  chatBubbleText: string;
  chatBotIcon: string;
  endMessage: string;
  endMessageButtonText: string;
  allowedAttachmentTypes:string[];
  allowedDomains: string[]
}

// Connection details object
export interface IConnectionDetails extends IChatServiceFields {
  contactFlowId: string
  instanceId: string,
  websocketUrl: string
  apiKey?: string
  customerDisconnectFlowId?: string
  attributes?: Record<string, string>
  config?: IChatConfigFields
}

// File uploads object
export interface IFileUpload {
  assumeARN: string
  assumePolicyARN?: string
  stsExternalId?: string
  bucket: string
  region: string
  fileTypes?: string[]
}

// End chat button object
export interface IEndChatButton {
  message: string
  text: string
}

// Font sources object
export interface IFontSources {
  name: string
  src: string
}

// Chat config dynamo record
export interface IChatConfig extends IChatConfigFields {
  companyID: string
  facia: string
  logoURL: string
  connectionDetails: Record<string, IConnectionDetails>
  urls: Record<string, string>
}

export interface IInstanceConfig {
  active: boolean;
  allowedDomains: string;
  contactAttributes?: Record<string, string>[];
  // agentDisplayName: string;
  // systemDisplayName: string;
  customerMessagePlaceholder: string;
  chatBubbleText: string
  // chatTabImage: string,
  chatBotIcon: string,
  // endChatButton: {
  //   message: string,
  //   text: string,
  // }
  endMessage: string,
  endMessageButtonText: string,
  allowedAttachmentTypes: string[],
  displayName: string;
}